<template>
  <div class="shine-loading" :style="[
    body_width && `width: ${body_width}px`,
    body_height && `height: ${body_height}px`,
  ]">
    <div
      class="line"
      :class="{ sm: size == 'sm' }"
      :style="{ width: width + '%' }"
    ></div>
  </div>
</template>

<script>
export default {
  name: 'ShineLoading',
  props: {
    size: {
      type: String,
      default: 'sm',
    },
    width: {
      type: [Number, String],
      default: 100,
    },
    body_width: {
      type: Number,
      default: null,
    },
    body_height: {
      type: Number,
      default: null,
    },
  },
}
</script>

<style scoped></style>
